export {
  arLocale,
  bgLocale,
  caLocale,
  csLocale,
  daLocale,
  deLocale,
  enGbLocale,
  esDoLocale,
  esLocale,
  esUsLocale,
  etLocale,
  fiLocale,
  frLocale,
  glLocale,
  heLocale,
  hiLocale,
  huLocale,
  idLocale,
  itLocale,
  jaLocale,
  koLocale,
  ltLocale,
  mnLocale,
  nbLocale,
  nlBeLocale,
  nlLocale,
  plLocale,
  ptBrLocale,
  roLocale,
  ruLocale,
  skLocale,
  slLocale,
  svLocale,
  thLocale,
  trLocale,
  viLocale,
  zhCnLocale
} from './chronos';
